// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__cLWuw","action":"styles_action__tjj-D"};